import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ToasterService } from 'angular2-toaster';
import { ApplicationStateService } from '../../services/application-state.service';
import { QuoteInfoService } from '../../services/quote-info.service';
import { BrowserWidthService } from "../../services/browser-width.service";
import { OptionsService } from "../../services/options.service";
import { InformationAsideModelsService } from "../../services/information-aside-models.service";

import { Model } from '../../model/model';

@Component({
    selector: 'toastr-html',
    template: `
    Selecting a new Product Line will remove all previous selections. 
    Continue with selection?
    <p><button class="yeti-button-primary-inverse"
    (click)="chooseYes()">Yes</button><button class="yeti-button-primary-inverse"
    (click)="chooseNo()">No</button></p>
    `,
    styles: ['.yeti-button-primary-inverse { width: 45%; }']
})
export class ToastrProductLinesComponent implements OnInit {

    constructor(
        private applicationStateService: ApplicationStateService,
        private toasterService: ToasterService,
        private router: Router,
        private quoteInfoService: QuoteInfoService,
        public browserWidthService: BrowserWidthService,
        private optionsService: OptionsService,
        private informationAsideModelsService: InformationAsideModelsService
    ) { }

    ngOnInit() {
        this.browserWidthService.disableBackground$.next(true);
        setTimeout(() => {
            this.browserWidthService.modalActive$.next(true);
        }, 1);
    }

    chooseYes() {
        this.browserWidthService.disableBackground$.next(false);
        this.browserWidthService.modalActive$.next(false);
        this.optionsService.initialOptionPageLoad$.next(true);
        if (this.applicationStateService.chosenProductLine) {
            this.applicationStateService.setProductLine(this.applicationStateService.chosenProductLine, true)
                .finally(() => {
                    if (this.applicationStateService.chosenProductLine.Metadata !== undefined && this.applicationStateService.chosenProductLine.Metadata !== null
                        && this.applicationStateService.chosenProductLine.Metadata.ModelId !== 0 !== null && this.applicationStateService.chosenProductLine.Metadata.ModelId !== 0) {
                        let m = new Model();
                        m.ModelId = this.applicationStateService.chosenProductLine.Metadata.ModelId;
                        this.informationAsideModelsService.checkModels(m);
                    } else {
                        this.router.navigateByUrl(`/choose-model/${this.applicationStateService.getApplicationState().quote.quoteId}`);
                    }
                })
                .subscribe(response => {
                    //this.applicationStateService.chosenProductLine = undefined;
                    this.toasterService.clear();
                    this.quoteInfoService.optionsTotal$.next(0.00);
                    this.applicationStateService.setQuote(response);
                });
        }
    }

    chooseNo() {
        this.browserWidthService.disableBackground$.next(false);
        this.browserWidthService.modalActive$.next(false);
        this.applicationStateService.chosenProductLine = undefined;
        this.toasterService.clear();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/toastr-productLines/toastr-html.component.ts